var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpLevel5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.884,
    height: 59.637,
    viewBox: "0 0 37.884 59.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1306",
    "data-name": "Rectangle 1306",
    width: 37.884,
    height: 59.637,
    transform: "translate(0 -5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1314",
    "data-name": "Rectangle 1314",
    width: 37.184,
    height: 54.637,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3076",
    "data-name": "Group 3076",
    transform: "translate(-1394 -560.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3059",
    "data-name": "Group 3059",
    transform: "translate(161.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32842",
    "data-name": "Path 32842",
    d: "M7.4,40H4l3.4,6.914L4,53.828H32.064l-1.029-6.914L32.064,40H36.04",
    transform: "translate(1195.513 616.846) rotate(-90)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32858",
    "data-name": "Path 32858",
    d: "M3.4,13.828H0L3.4,6.914,0,0H28.064L27.035,6.914l1.029,6.914H32.04",
    transform: "translate(1252.658 612.846) rotate(-90)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32844",
    "data-name": "Path 32844",
    d: "M13.464,52.739H1.456A1.456,1.456,0,0,1,.168,50.606L3.45,44.37.168,38.134A1.456,1.456,0,0,1,1.456,36H28.464a1.456,1.456,0,0,1,0,2.911H3.867l2.516,4.781a1.457,1.457,0,0,1,0,1.356L3.867,49.828h9.6a1.456,1.456,0,0,1,0,2.911",
    transform: "translate(1198.058 614.301) rotate(-90)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32859",
    "data-name": "Path 32859",
    d: "M13.464,0H1.456A1.456,1.456,0,0,0,.167,2.134L3.45,8.37.167,14.606a1.456,1.456,0,0,0,1.288,2.134H28.464a1.456,1.456,0,1,0,0-2.911H3.867L6.383,9.048a1.457,1.457,0,0,0,0-1.356L3.867,2.911h9.6a1.456,1.456,0,1,0,0-2.911",
    transform: "translate(1251.203 614.301) rotate(-90)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988",
    transform: "translate(1232.058 565.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32781",
    "data-name": "Path 32781",
    d: "M43.869,86.882v20.126l-9.493-4.177-9.493,4.177V86.882Z",
    transform: "translate(-15.434 -53.89)",
    fill: "#c4e27a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32782",
    "data-name": "Path 32782",
    d: "M59.376,86.882H49.883v15.949l9.493,4.177Z",
    transform: "translate(-30.941 -53.89)",
    fill: "#c4e27a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32783",
    "data-name": "Path 32783",
    d: "M34.376,86.882H24.883v5.9s6.559,3.486,9.493,4.8Z",
    transform: "translate(-15.434 -53.89)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32784",
    "data-name": "Path 32784",
    d: "M49.883,86.882V97.461c3.344-1.6,6.5-3.252,9.493-4.677v-5.9Z",
    transform: "translate(-30.941 -53.89)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32785",
    "data-name": "Path 32785",
    d: "M41.388,106.046a1.517,1.517,0,0,1-.611-.129L31.9,102.009l-8.882,3.908a1.519,1.519,0,0,1-2.131-1.39V84.4A1.519,1.519,0,0,1,22.4,82.882H41.389A1.519,1.519,0,0,1,42.907,84.4v20.126a1.519,1.519,0,0,1-1.519,1.519M31.9,98.831a1.517,1.517,0,0,1,.612.129L39.87,102.2V85.92H23.921V102.2l7.363-3.239a1.517,1.517,0,0,1,.612-.129",
    transform: "translate(-12.953 -51.409)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32786",
    "data-name": "Path 32786",
    d: "M48.022,107.633a1.139,1.139,0,0,1-1.139-1.139V93.927a1.139,1.139,0,0,1,2.278,0v12.567a1.139,1.139,0,0,1-1.139,1.139",
    transform: "translate(-29.08 -57.553)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1388",
    "data-name": "Rectangle 1388",
    width: 58,
    height: 45,
    transform: "translate(-10.058 -3.863)",
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987",
    transform: "translate(1394 561.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32851",
    "data-name": "Path 32851",
    d: "M10.5,39.48l5.959,3.487a9.158,9.158,0,0,0,9.239,0l5.959-3.487a13.129,13.129,0,0,0,6.5-11.28V11.619l-.828-.124a31.539,31.539,0,0,1-15.578-6.87L21.074,4l-.669.627A31.383,31.383,0,0,1,4.828,11.495L4,11.619V28.2a13.129,13.129,0,0,0,6.5,11.28",
    transform: "translate(-2.482 -2.482)",
    fill: "#bcc5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32852",
    "data-name": "Path 32852",
    d: "M9.312,16.043l1.622-.487a37.7,37.7,0,0,0,8.953-4.009l1.194-.736,1.194.735a37.905,37.905,0,0,0,8.94,4.008l1.62.488v6.093q2.659-.155,5.312-.379V11.62l-.828-.124A31.544,31.544,0,0,1,21.742,4.626L21.074,4l-.669.626A31.382,31.382,0,0,1,4.828,11.5L4,11.62V21.755q2.653.225,5.312.379Z",
    transform: "translate(-2.482 -2.482)",
    fill: "#d3d9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32855",
    "data-name": "Path 32855",
    d: "M18.592,43.254A10.673,10.673,0,0,1,13.206,41.8L7.246,38.308A14.652,14.652,0,0,1,0,25.718V9.137a1.518,1.518,0,0,1,1.293-1.5l.828-.124A30.185,30.185,0,0,0,16.892,1.031L17.554.41a1.518,1.518,0,0,1,2.076,0l.669.626A30.327,30.327,0,0,0,35.064,7.512l.828.124a1.518,1.518,0,0,1,1.293,1.5V25.718a14.652,14.652,0,0,1-7.247,12.59L23.978,41.8a10.675,10.675,0,0,1-5.386,1.459M3.035,10.441V25.718a11.607,11.607,0,0,0,5.744,9.971l5.959,3.487a7.641,7.641,0,0,0,7.707,0L28.4,35.689a11.607,11.607,0,0,0,5.744-9.971V10.441A33.327,33.327,0,0,1,18.593,3.575,33.128,33.128,0,0,1,3.035,10.441",
    transform: "translate(0 0)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32856",
    "data-name": "Path 32856",
    d: "M28.521,49.564a4.6,4.6,0,0,1-2.32-.627L20.242,45.45A8.561,8.561,0,0,1,16,38.1V25.941a.759.759,0,0,1,.541-.727l1.622-.487A36.952,36.952,0,0,0,26.936,20.8l1.194-.736a.758.758,0,0,1,.8,0l1.195.735a37.124,37.124,0,0,0,8.761,3.927l1.62.488a.759.759,0,0,1,.54.727V38.1A8.561,8.561,0,0,1,36.8,45.45l-5.959,3.487a4.6,4.6,0,0,1-2.32.628m-11-23.058V38.1a7.036,7.036,0,0,0,3.49,6.04l5.959,3.487a3.136,3.136,0,0,0,3.108,0l5.959-3.487a7.036,7.036,0,0,0,3.49-6.04V26.5l-1.08-.326a38.662,38.662,0,0,1-9.119-4.088l-.8-.49-.8.491a38.437,38.437,0,0,1-9.133,4.09Z",
    transform: "translate(-9.929 -12.381)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32857",
    "data-name": "Path 32857",
    d: "M34.324,54.23a.411.411,0,0,1-.29-.116.389.389,0,0,1-.124-.3V43.048a.39.39,0,0,1,.124-.3.413.413,0,0,1,.29-.116h1.789a.55.55,0,0,1,.406.141.783.783,0,0,1,.174.223l2.916,5.235L42.524,43a1.66,1.66,0,0,1,.174-.223.516.516,0,0,1,.406-.141h1.772a.434.434,0,0,1,.307.116.39.39,0,0,1,.124.3V53.816a.389.389,0,0,1-.124.3.433.433,0,0,1-.307.116H42.9a.431.431,0,0,1-.307-.116.389.389,0,0,1-.124-.3V47.6L40.6,51.066a.757.757,0,0,1-.2.265.534.534,0,0,1-.364.116h-.861a.533.533,0,0,1-.364-.116.973.973,0,0,1-.216-.265L36.726,47.6v6.212a.4.4,0,0,1-.414.414Z",
    transform: "translate(-21.044 -26.458)",
    fill: "#4a4e59"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpLevel5);
export default __webpack_public_path__ + "static/media/xpLevel5.a205e75aa156d51bf45b90ff85ceefc9.svg";
export { ForwardRef as ReactComponent };